import { useContext } from 'react';
import { ChatFilter } from '../../types/chats';
import { ChatContext } from '../../context/ChatContext/context';

function useChatFilters() {
  const {
    state: { filter },
    dispatch,
  } = useContext(ChatContext);

  const onFilter = (val: ChatFilter) => {
    dispatch({
      type: 'SET_FILTER',
      payload: val,
    });
  };

  const onReset = () => {
    dispatch({
      type: 'RESET',
    });
  };

  return {
    filter,
    onFilter,
    onReset,
  };
}

export default useChatFilters;
